<template>
  <BaseTemplate>
    <div class="password-reissue">
      <Title :jpn="t('確認コードを入力')" />
      <div class="description">
        <span class="text">{{ t('メールで送信された確認コードを入力してください。') }}</span>
      </div>
      <div class="mail-text-container">
        <LabelInput
          class="label-input"
          labelText="code"
        >
          <TextBox
            class="text-box mail"
            placeholder=""
            maxlength="20"
            @handleTextInput="inputMail"
          />
        </LabelInput>
        <ErrorMessage
          v-if="errorMessageMail"
          class="error-message"
          :message="errorMessageMail"
        />
      </div>
      <BuyButton
        class="square-button send-mail"
        :text="t('確認')"
        :isArrow="false"
        @handleSquareBtnClick="sendPasswordMail"
      />
    </div>
  </BaseTemplate>
</template>

<script>
import { mapGetters } from 'vuex';

import BaseTemplate from '@/components/templates/BaseTemplate.vue';
import TextBox from '@/components/atoms/TextBox.vue';
import ErrorMessage from '@/components/atoms/ErrorMessage.vue';
import LabelInput from '@/components/molecules/LabelInput.vue';
import Title from '@/components/molecules/Title02.vue';
import t from '@/plugins/i18n';
import BuyButton from '@/components/atoms/BuyButton.vue';

export default {
  name: 'PasswordReissue',
  mixins: [t],

  components: {
    BaseTemplate,
    TextBox,
    ErrorMessage,
    Title,
    LabelInput,
    BuyButton,
  },

  data: () => ({
    mail: null,
    errorMessageMail: null,
  }),

  computed: {
    ...mapGetters({
      reissuePasswordResult: 'user/reissuePasswordResult',
    }),
  },

  watch: {
    reissuePasswordResult(newVal) {
      if (newVal) {
        if (newVal.state === 200) {
          this.$store.dispatch('user/clearReissuePasswordResult');
          this.$router.push('/complete-password-reissue');
        } else {
          const { mail } = newVal.errors;
          this.errorMessageMail = mail ? mail[0] : null;
        }
      }
    },
  },

  methods: {
    inputMail(mail) {
      this.mail = mail;
    },
    sendPasswordMail() {
      const postParams = {
        code: this.mail,
      };
      this.$store.dispatch('user/reissuePassword', { postParams });
    },
  },
};
</script>

<style lang="scss" scoped>
.password-reissue{
  max-width: 680px;
  min-height: 100%;
  padding: 70px 30px 0px;
  margin: 0px auto;
  text-align: center;
  .password-reissue-title{
    .text{
      height: 35px;
      font-family: $notoSerif;
      font-size: 24px;
      font-weight: 700;
    }
  }
  .description{
    display: flex;
    flex-direction: column;
    height: 43px;
    margin-top: 40px;
    .text{
      font-family: $notoSans;
      font-size: 14px;
      line-height: 23.4px;
    }
  }
  .mail-text-container{
    width: 315px;
    margin: 20px auto 0 auto;
    .label-input {
      color: initial;
    }
    .text-box{
      &.mail{
      }
    }
  }
  .square-button{
    width: 200px;
    height: 50px;
    margin: 40px auto 0px;
  }
  .error-message {
    margin-top: 2px;
    padding: 2px 10px;
  }
}
</style>
